import { createSlice } from '@reduxjs/toolkit';
import { ERROR } from 'types';
import { CreatorDiscoveryReducerState } from 'types/creator-discovery';
import { fetchDiscoveredCreatorThunk } from './thunk';

const initialState: CreatorDiscoveryReducerState = {
    loading: false,
    error: null,
    creator: {},
};

const creatorDiscoverySlice = createSlice({
    name: 'creatorDiscovery',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchDiscoveredCreatorThunk.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchDiscoveredCreatorThunk.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.error = null;

                const { discoveryId, socialAccountId, creator } = payload;
                const existingCreators = state.creator[discoveryId] ?? {};

                state.creator[discoveryId] = {
                    ...existingCreators,
                    [socialAccountId]: {
                        creator,
                        last_fetched_at: Date.now(),
                    },
                };
            })
            .addCase(fetchDiscoveredCreatorThunk.rejected, (state, { payload }) => {
                state.loading = false;
                if (payload !== ERROR.CACHED) {
                    state.error = payload || 'Failed to fetch discovered creator';
                }
            });
    },
});

export default creatorDiscoverySlice.reducer;
